/**
 * Messagerie formateurs (BO) endpoints
 */
export const messagesFormateurEndpoints = {
  threads: () => '/api/messages/formateurs',
  unreadCount: () => '/api/messages/formateurs/unread-count',
  rechercheFormateurs: (q) => `/api/messages/formateurs/recherche?q=${encodeURIComponent(q)}`,
  heartbeat: () => '/api/messages/formateurs/heartbeat',
  thread: (id) => `/api/messages/formateurs/${id}`,
  formateurPresence: (id) => `/api/messages/formateurs/${id}/presence`,
  repondre: (id) => `/api/messages/formateurs/${id}`,
  marquerLu: (id) => `/api/messages/formateurs/${id}/lu`,
}
